<div id="wrapper">
  <mat-progress-bar *ngIf="done" mode="determinate" value="100" color="accent" ></mat-progress-bar>
  <mat-progress-bar *ngIf="!done" mode="query"></mat-progress-bar>
  <button mat-icon-button (click)="deleteMe()"><mat-icon svgIcon="app_trash"></mat-icon></button>
</div>
<span>{{label}}</span>
